import { CryptJsSettingsInRegisterFav } from './../../../constant/crypt-js-settings';
import { CryptJsManager } from './../../share/crypt-js/crypt-js-manager';
import { AuthenticateService } from './../../share/authenticate/authenticate.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/** お気に入り登録専用の自動サインインページ。各画面のお気に入り登録ページより、当ComponentのURLをお気に入り登録できる。 */
@Component({
  selector: 'app-favorite-signin',
  templateUrl: './favorite-signin.component.html',
  styleUrls: ['./favorite-signin.component.css']
})
export class FavoriteSigninComponent implements OnInit {

  isLoading = true;
  autoInput = {
    username: null,
    password: null,
  };

  constructor(
    private route: ActivatedRoute,
    private authServ: AuthenticateService,
  ) { }

  ngOnInit() {
    // クエリパラメータを取得し、自動サインインを実施。
    this.route.queryParams.subscribe(
      params => {
        this.autoInput.username = params['u'];
        this.autoInput.password = CryptJsManager.decrypt(params['c'], CryptJsSettingsInRegisterFav.KEY, CryptJsSettingsInRegisterFav.IV);
        this.signin();
      }
    );
  }

  public async signin() {
    this.authServ.signIn(this.autoInput.username, this.autoInput.password);
  }
}
